<template>
    <div :auth_level="auth_level">
        <template v-if="auth_level >= route_auth_level(this)">
            <b-container :fluid="this.$router.currentRoute.meta.fullwidth ? '100' : 'lg'" class="app-wrapper">
                <navbar v-if="route_navbar(this)" />

                <PageTitle :value="$router.currentRoute.meta.title"/>

                <RouterView />
            </b-container>
        </template>
        <template v-else>
            <auth-mask />
        </template>
        <load-mask v-if="Object.keys($store.state.axios.queue).length" />
        <Notifications />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AuthMask from '@/components/AuthMask'
import LoadMask from '@/components/LoadMask'
import Navbar from '@/components/Navbar'
import Notifications from '@/components/Notifications'
import PageTitle from '@/components/PageTitle.vue'

export default {
    components: {
       AuthMask,
       LoadMask,
       Navbar,
       Notifications,
       PageTitle,
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'auth_name',
            'route_auth_level',
            'route_navbar',
        ])
    },
    methods: {
    },
    mounted() {
        window.addEventListener('popstate', () => {
console.log(this.$router)
//console.log(this.$router.currentRoute.params.item_uuid)
        })
    },
}
</script>
